import { SmsValidNumberResponse } from '../sms';

export class MobileNumberValidateUtility {

    //We only support australian numbers and really, it should be handled by each of the strategies as some
    //may require country codes to be sent in a particular way, or a very specific regarding how they need numbers to be formatted
    public static validateNumber(number: string): SmsValidNumberResponse {
        const response = {
            valid: false,
            originalNumber: number
        } as SmsValidNumberResponse;

        if (!number) {
            return response;
        }

        let mobileNumber = number;
        //strip all the spaces and potential weird characters such as + in a valid number
        mobileNumber = mobileNumber.replace(/\s/g, "").replace("/\+/g", "");
        let valid = false;
        //Starts with a 614 and has exactly 8 other digits
        if (/^614\d{8}$/.test(mobileNumber)) {
            valid = true;
        }
        //Starts with a 6104 and has exactly 8 other digits, strip the 0
        else if (/^6104\d{8}$/.test(mobileNumber)) {
            mobileNumber = "614" + mobileNumber.substring(4);
            valid = true;
        }
        //if it starts with 04, it should be 10 characters (e.g. 0410 555 555), and we should replace the 0 with 61
        else if (/^04\d{8}$/.test(mobileNumber)) {
            //Its a valid number once we replace the starting 0 and add 61 to the beginning of it
            mobileNumber = "61" + mobileNumber.substring(1);
            valid = true;
        }
        //if it starts with 4, it should be 9 characters (e.g. 410 555 555), and we should add 61
        else if (/^4\d{8}$/.test(mobileNumber)) {
            //Its a valid number once we replace the starting 0 and add 61 to the beginning of it
            mobileNumber = "61" + mobileNumber;
            valid = true;
        }
        if (valid) {
            response.valid = true;
            response.formattedNumber = mobileNumber;
        }
        return response;
    }

}